import {
  PRODUCT_IDS,
  RESIDENTIAL, COMMERCIAL, PRODUCT_TYPES,
} from 'constants/AppConstants';
import { getProductType } from 'utils/app.utils';

export const STRUCTURE_TYPES = { 1: RESIDENTIAL, 2: COMMERCIAL };

export const PRODUCT_SELECTION_WALLS_IDS = [34, 35, 51, 85, 86, 107, 108];

export const PRODUCT_SELECTION_FULL_HOUSE_IDS = [99, 111];

export const PRODUCT_SELECTION_OTHER_IDS = [37, 38, 39, 41];

export const ROOF_PRODUCT_TYPES = [
  PRODUCT_TYPES.CATReady,
  PRODUCT_TYPES.ClaimsReady,
  PRODUCT_TYPES.D2,
  PRODUCT_TYPES.D3,
  PRODUCT_TYPES.InstallerReport,
  PRODUCT_TYPES.Premium,
  PRODUCT_TYPES.Solar,
  PRODUCT_TYPES.Standard,
  PRODUCT_TYPES.ParkingLot,
  PRODUCT_TYPES.Images,
  PRODUCT_TYPES.Complete,
  PRODUCT_TYPES.Partial,
  PRODUCT_TYPES.QuickSquares,
  PRODUCT_TYPES.Gutter,
  PRODUCT_TYPES.Diagram,
  // PRODUCT_TYPES.RoofGeometry, actually risk management product
  PRODUCT_TYPES.QuickSquaresExtendedCoverage,
  PRODUCT_TYPES.Blueprint,
  PRODUCT_TYPES.BidPerfect, // ,
  // PRODUCT_TYPES.WholeHome
];

export const isRoofProduct = (product) => ROOF_PRODUCT_TYPES.includes(getProductType(product));

export const getWallsPreferenceByProductId = (productId) => {
  switch (productId) {
    case PRODUCT_IDS.WallsAddOn:
    case PRODUCT_IDS.PremiumResidentialWallonly:
    case PRODUCT_IDS.PremiumCommercialWallonly: return 'wallsAddOnProduct';
    case PRODUCT_IDS.WallsLite: return 'wallsLiteProduct';
    case PRODUCT_IDS.ResWallWinDoor:
    case PRODUCT_IDS.WallWinDoor:
      return 'resWallWinDoorProduct';
    case PRODUCT_IDS.ResWallsFKALite:
    case PRODUCT_IDS.WallsFKALite:
      return 'resWallsFKALiteProduct';
    default: return null;
  }
};
